import { createSelector } from '@ngrx/store';
import { getAuthSession } from '../auth.selectors';
import { AuthSessionStateInterface } from './auth-session.state';

export const getActiveUser = createSelector(
  getAuthSession,
  (state: AuthSessionStateInterface) => state.activeUser
);
